import { inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DateTime } from "luxon";
import { map } from "rxjs";
import { TicketBatch } from "../shared/components/modal-tickets/types/ticket-batch.type";

export function getParams(paramName: string) {
  const activatedRoute = inject(ActivatedRoute);
  return activatedRoute.params.pipe(map((params) => params[paramName]));
}

export function getQueryParam(paramName: string) {
  const activatedRoute = inject(ActivatedRoute);
  return activatedRoute.queryParamMap.pipe(
    map((params) => params.get(paramName)),
  );
}

export function getQueryParamAsConst(paramName: string) {
  const activatedRoute = inject(ActivatedRoute);
  return activatedRoute.snapshot.queryParamMap.get(paramName);
}

/**
 * Respeita a sequência da API; mantém ordem de criação para lotes ainda locais.
 * @param batches - Array de lotes de ingressos
 * @returns Array ordenado de lotes de ingressos
 */
export function sortBatchesByStartDate(batches: TicketBatch[]) {
  if (!Array.isArray(batches) || batches.length === 0) {
    return [];
  }

  if (batches.some((batch) => batch.sequence_number != null)) {
    return [...batches].sort(
      (a, b) =>
        (a.sequence_number ?? Number.MAX_SAFE_INTEGER) -
        (b.sequence_number ?? Number.MAX_SAFE_INTEGER),
    );
  }
  if (batches.some((batch) => batch.transition_mode != null))
    return [...batches];
  return [...batches].sort((a, b) => {
    // ISO com offset (-03:00) funciona bem com Luxon
    const dateA = DateTime.fromISO(a.sale_start ?? "");
    const dateB = DateTime.fromISO(b.sale_start ?? "");

    const msA = dateA.isValid ? dateA.toMillis() : Number.POSITIVE_INFINITY;
    const msB = dateB.isValid ? dateB.toMillis() : Number.POSITIVE_INFINITY;

    // asc: mais antigo -> mais recente
    return msA - msB;
  });
}
